<template>
  <div class="insights-ai-usage d-flex flex-column gap-20 pt-10">
    <div class="row">
      <div class="col-md-4 mb-20 mb-md-0">
        <InsightsAiUsageSummaryWidget />
      </div>
      <div class="col-md-8">
        <InsightsAiUsageModelsWidget />
      </div>
    </div>
    <InsightsAiUsageTrendWidget />
    <InsightsAiUsageMembersWidget />
  </div>
</template>

<script>
export default {
  name: 'InsightsAiUsage',
  components: {
    InsightsAiUsageSummaryWidget: () => import('~/components/insights/InsightsAiUsageSummaryWidget.vue'),
    InsightsAiUsageModelsWidget: () => import('~/components/insights/InsightsAiUsageModelsWidget.vue'),
    InsightsAiUsageTrendWidget: () => import('~/components/insights/InsightsAiUsageTrendWidget.vue'),
    InsightsAiUsageMembersWidget: () => import('~/components/insights/InsightsAiUsageMembersWidget.vue'),
  },
};
</script>
